import { combineReducers } from 'redux';
import accoutReducer from './accoutReducer';

export const rootReducer = combineReducers({
  account: accoutReducer,
});

export default rootReducer;
